const QueryParams = require('../../../page/frontend/helpers/params');

module.exports = class DealFetcher {
  constructor(csrfToken) {
    this.csrfToken = csrfToken;
    this.cachedPaginatedCards = {};
  }

  fetchLazyLoadedCards(lazyLoadedSectionIndex = 1) {
    const paramObject = Groupon.Utils.unparam();
    paramObject['_csrf'] = this.csrfToken;
    paramObject['index'] = lazyLoadedSectionIndex;

    const url = `/partial/homepage/get-lazy-loaded-cards?${QueryParams.toString(
      paramObject
    )}`;

    return fetch(url, { credentials: 'include' })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return Promise.resolve(data);
      });
  }

  fetchPaginatedCards(page) {
    const context = this;

    const cachedPaginatedCard = context.cachedPaginatedCards[page];

    const paramObject = Groupon.Utils.unparam();
    paramObject['_csrf'] = this.csrfToken;

    const url = `/partial/homepage/get-paginated-cards?${QueryParams.toString(
      paramObject
    )}`;

    if (cachedPaginatedCard) {
      return Promise.resolve(cachedPaginatedCard);
    } else {
      return fetch(url, { credentials: 'include' })
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response);
          } else {
            return Promise.reject(response);
          }
        })
        .then(response => {
          return response.json();
        })
        .then(data => {
          context.cachedPaginatedCards[page] = data;

          return Promise.resolve(data);
        });
    }
  }
};
